export default [
    { code: 'GET', name: 'GET' },
    { code: 'POST', name: 'POST' },
];
